import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../validators/cdn-asset-options';
export const defaultItemPickerCdnOptions = {
    itemThumbnail: { width: 520 },
    itemImage: { width: 640 },
    itemOptionImage: { width: 120 }
};
export const itemPickerCdnOptionsValidator = Validator.object({
    itemThumbnail: cdnStandardAssetOptionsValidator,
    itemImage: cdnStandardAssetOptionsValidator,
    itemOptionImage: cdnStandardAssetOptionsValidator
});
